.header {
    padding-bottom: var(--mantine-spacing-lg);
}

.dragHandle {
    background-color: transparent;
    &:hover {
        background-color: transparent;
        color: var(--mantine-color-gneis-2);
    }
}

.overlay {
    background: rgba(0, 0, 0, 0.55);
    transition: background 1s ease-in-out;
}

.overlayDragging {
    background: rgba(0, 0, 0, 0.15);
}
